import React from 'react';
import PublicPageLayout from '../../components/PublicPageLayout';
import {Clock} from './PSAOperationalStatistics';
import {io} from 'socket.io-client';
import {LoadGraphic} from '../../components/Common';
import moment from 'moment';
import u from '../../utilities/Utilities';
import store from 'store';
import {Link} from 'react-router-dom';
import "../../styles/dashboard-generic.scss";
import "../../styles/dashboards/psa-dashboards.scss";

export default class PSAOperationalStatus extends React.Component{

    socketType="Operational Status";

    tableRows=10;

    pollInterval=60000;

    dormID = this.props.match.params.dormID;

    state={
        content:{
            tables:[],
        },
        instantiated:false,
    };

    componentDidMount=()=>{
        //this.getSocketInfo();

        this.getContent();

        this.contentInterval=setInterval(()=>{
            this.getContent();
        },this.pollInterval);
    }

    componentWillUnmount=()=>{
        clearInterval(this.contentInterval);
    }

    getContent=()=>{
        this.setState({error:""});
        u.post({
            url:"/api/get-dashboard-content",
            data:{
                dormID:this.dormID,
                type:this.socketType,
            },
            success:(content)=>{
                this.setState({content:content,instantiated:true});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getSocketInfo=()=>{
        this.setState({loading:true,loadText:"Getting server info..."});
        u.post({
            url:"/api/get-socket-info",
            data:{},
            success:({socketIP,socketToken})=>{
                this.token=socketToken;
                this.socketIP=socketIP;
                this.setupSocket();
            },
            error:(error)=>{
                this.setState({loadText:error});
            }
        })
    }

    setupSocket=()=>{
        this.socket = io(this.socketIP,{
            reconnectionDelayMax: 5000,
            withCredentials: true,
            extraHeaders:{
                "csrf-token":store.get("csrfToken"),
                "socket-token":this.token,
            },
            transports:["websocket"],
        });

        this.socket.on('connect',()=>{
            this.setState({sessionID:this.socket.id,connected:true});
            //Initial Emit
            this.socket.emit("get-base-state",
            {
                socketID:this.socket.id,
                socketType:this.socketType,
            });
        });

        this.socket.on("disconnect",()=>{
            this.setState({connected:false});
        });

        this.socket.on("set-base-state",(content)=>{
            let modContent = this.modContent(content);
            this.setState({content:modContent});
        });
    }

    modContent=(content)=>{
        return content;
    }

    psaColors=[
      u.hexToRgb("#229dce"),
      u.hexToRgb("#37a7b6"),
      u.hexToRgb("#63c08a"),
      u.hexToRgb("#8ed75e"),
      u.hexToRgb("#a5e348"),
      u.hexToRgb("#cac9d0"),
    ];

    onSelectHeader=(tableIndex,headerIndex)=>{
        let content=this.state.content;
        content.tables = content.tables.map(
            (item,tIndex)=>{
                item.headers = item.headers.map(
                  (header,hIndex)=>{
                      if(!(tIndex == tableIndex && hIndex == headerIndex)){
                        header.selected=false;
                        header.twice=false;
                      }
                      return header;
                  }
                )
                return item;
            }
        );
        let header = content.tables[tableIndex].headers[headerIndex];
        let searchDescending=true;
        if(header.selected){
            header.twice=!header.twice;
            searchDescending=!header.twice;
        }
        else{
            header.selected=true;
            searchDescending=true;
        }

        //Perform sort
        let sortContent = content.tables[tableIndex].content;
        sortContent = sortContent.sort(
            (a,b)=>{
                if(searchDescending){
                    return (a[header.field] > b[header.field]) ? -1 : 1;
                }
                return (a[header.field] < b[header.field]) ? -1 : 1;
            }
        );

        this.setState({content:content});
    }

    render=()=>{
        const content=this.state.content;

        return(
            <PublicPageLayout url="/psa-operational-status" title={this.socketType}>
                <LoadGraphic active={!this.state.instantiated} text="Preparing"/>

                <div className="psa-dashboard-header-container" style={{height:"0"}}>
                    <div className="psa-dashboard-header">
                        <div className="pdh-title"><h2>{this.socketType.toUpperCase()}</h2></div>
                        <div className='pdh-title right'><h2><Clock/></h2></div>
                    </div>
                </div>

                <div className="psa-tables-container">
                    {
                        content.tables.map(
                            (item,index)=>{
                                let padLength = (this.tableRows - item.content.length);
                                if(padLength < 0){
                                    padLength = 0;
                                }
                                const tablePadding=Array(padLength).fill("");

                                return (
                                    <div key={index} className={"psa-table-container " + (index%2==0 ? "tleft" : "tright")}>
                                        <h3 className="psa-table-title" style={{color:this.psaColors[index].hex}}>{item.label}</h3>
                                        <div className="psa-table">
                                            <table>
                                                <thead className={(item.content.length > this.tableRows ? "oversize" : "")} style={{backgroundColor:this.psaColors[index].hex}}>
                                                    <tr>
                                                        {
                                                            item.headers.map(
                                                                (header,h)=>{
                                                                    return (
                                                                        <th key={h}
                                                                            style={{backgroundColor:this.psaColors[index].hex}}
                                                                            onClick={()=>{this.onSelectHeader(index,h)}}
                                                                            >
                                                                        {header.label}
                                                                        {
                                                                            (header.selected)
                                                                                ?
                                                                                <img src="/images/app/nav-triangle.png" className={"dashboard-selected" + ((header.twice) ? " twice" : "")}/>
                                                                                :
                                                                                null
                                                                        }
                                                                        </th>
                                                                    )
                                                                }
                                                            )
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody style={{maxHeight:(40*this.tableRows)+"px"}}>
                                                    {
                                                        item.content.map(
                                                            (row,ri)=>{
                                                                return (
                                                                    <Link key={ri} to={u.linkReplace(item.link,row)}>
                                                                        <tr className={"item " + (ri%2 == 0 ? "even" : "odd")}>
                                                                          {
                                                                            item.headers.map(
                                                                                (header,j)=>{
                                                                                    return (
                                                                                        <td key={(ri*item.headers.length) + j}>
                                                                                                {row[header.field]}
                                                                                        </td>
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                        </tr>
                                                                    </Link>
                                                                )
                                                            }
                                                        )
                                                    }
                                                    {
                                                        tablePadding.map(
                                                            (emptyRow,ei)=>{
                                                                return(
                                                                    <tr key={index} className={"item " + ((item.content.length + ei)%2 == 0 ? "even" : "odd")}>
                                                                      {
                                                                        item.headers.map(
                                                                            (header,j)=>{
                                                                                return (
                                                                                    <td key={(ei*item.headers.length) + j}>
                                                                                            <div className="pad">NONE</div>
                                                                                    </td>
                                                                                )
                                                                            }
                                                                        )
                                                                    }
                                                                    </tr>
                                                                )
                                                            }
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )
                            }
                        )
                    }
                </div>
            </PublicPageLayout>
        )
    }
}
